<div class="p-absolute h-100 w-100 d-flex flex-center loading-overlay">
  @if (!noSpinner) { <div class="dot-stretching"></div> }
</div>
